import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import TabBar from "../../components/ui/TabBar";
import Tab from "../../components/ui/Tab";
import useGet from "../../hooks/useGet";
import usePost from "../../hooks/usePost";
// import usePrevious from "../../hooks/usePrevious";
import LoadingOverlay from "../../components/shared/LoadingOverlay";

import PortalSalesDetails from "../../components/portal/PortalSalesDetails";
import PortalOpsDetails from "../../components/portal/PortalOpsDetails";
import PortalDetailsHeader from "../../components/portal/PortalDetailsHeader";
import PortalFinanceDetails from "../../components/portal/PortalFinanceDetails";

const PortalDealDetails = ({ view, theDealId }) => {
    const params = useParams();
    const location = useLocation();
    const tabLinkState = location.state?.returnTo ? { returnTo: location.state.returnTo } : undefined;
    const [dealId] = useState(params.dealId);
    const selectedView = params.view;
    // const prevView = usePrevious(params.view); // currently unused but may be needed for future view-change logic

    const [detailsTab, setDetailsTab] = useState("sales");

    const [dealDataUrl, setDealDataUrl] = useState(null);
    const [legDataUrl, setLegDataUrl] = useState(null);

    const { loading: dealLoading, returnData: dealData } = useGet(dealDataUrl);
    const { loading: legLoading, returnData: legData } = useGet(legDataUrl);

    const [actualLegData, setActualLegData] = useState([]);
    const { returnMessage, postData } = usePost();

    // TODO: Decide whether to rely on navigation state or always refetch by ID.

    useEffect(() => {
        if (!dealId) return;
        setDealDataUrl(`/api/portal/deal-by-zohoid?dealId=${dealId}`);
        setLegDataUrl(`/api/portal/legDetails?dealId=${dealId}`);
    }, [dealId]);

    useEffect(() => {
        if (legData) setActualLegData(legData);
    }, [legData]);

    useEffect(() => {
        //console.log(params.view)
        //if(prevView !== view) {
        if (selectedView) {
            setDetailsTab(selectedView);
            //console.log(detailsTab)
        }
        //}
    }, [selectedView]);

    useEffect(() => {
        if (returnMessage.success) {
            window.location.reload();
        }
    }, [returnMessage.success, returnMessage]);

    const deleteLeg = (leg) => {
        postData({}, `/api/portal/delete-leg?dealId=${leg["deal.id"]}&damRef=${leg.daM_Ref}&zohoId=${leg.id}`);
    };

    return (
        <>
            <div className={"portal__deal_details"}>
                <PortalDetailsHeader deal={dealData} />

                {
                    <TabBar>
                        <Link to={`/portal/deal-details/sales/${dealId}`} replace state={tabLinkState}>
                            <Tab selected={detailsTab === "sales"}>
                                <span className="tab__text--full">SALES & COMMERCIAL</span>
                                <span className="tab__text--short">S & C</span>
                            </Tab>
                        </Link>
                        <Link to={`/portal/deal-details/ops/${dealId}`} replace state={tabLinkState}>
                            <Tab selected={detailsTab === "ops"}>
                                <span className="tab__text--full">OPERATIONS</span>
                                <span className="tab__text--short">OPS</span>
                            </Tab>
                        </Link>
                        <Link to={`/portal/deal-details/finance/${dealId}`} replace state={tabLinkState}>
                            <Tab selected={detailsTab === "finance"}>
                                <span className="tab__text--full">FINANCE</span>
                                <span className="tab__text--short">FINANCE</span>
                            </Tab>
                        </Link>
                    </TabBar>
                }

                <div
                    className={`portal__details_content ${
                        detailsTab === "sales"
                            ? "portal__details_content--sales"
                            : detailsTab === "ops"
                              ? "portal__details_content--ops"
                              : detailsTab === "finance"
                                ? "portal__details_content--finance"
                                : ""
                    }`}
                >
                    {detailsTab === "sales" && (
                        <>
                            <PortalSalesDetails deal={dealData} legs={actualLegData} onDeleteLeg={deleteLeg} />
                        </>
                    )}

                    {detailsTab === "ops" && (
                        <>
                            <PortalOpsDetails deal={dealData} legs={actualLegData} />
                        </>
                    )}

                    {detailsTab === "finance" && (
                        <>
                            <PortalFinanceDetails deal={dealData} legs={actualLegData} />
                        </>
                    )}
                </div>
            </div>

            {(dealLoading || legLoading) && <LoadingOverlay />}
        </>
    );
};

export default PortalDealDetails;
